import * as images from "@/components/images/Images_second";
import { IndustryCard } from "@/components/screen/global-components/industry/IndustryCardsCarousel";

const useCaseIndustriesContent = {
  title: "Scale globally with industry specialized translators",
  description:
    "Linguists with industry subject matter expertise ensure accurate, high-quality translations that are convenient, fast, reliable, and secure at any volume. ",
};

const useCaseIndustriesCards: IndustryCard[] = [
  {
    title: "Education",
    description:
      "Specialized translations for educational reports, academic documents, and instructional materials, ensuring accuracy, clarity, and compliance with educational standards.",
    imageUrl: images.technical_industries1,
    link: "/use-cases/academic",
  },
  {
    title: "Finance",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision. ",
    imageUrl: images.technical_industries2,
    link: "/use-cases/financial",
  },
  {
    title: "Government",
    description:
      "Specialized translations for official documents, policies, and reports, ensuring accuracy, clarity, and compliance with regulatory standards.",
    imageUrl: images.technical_industries3,
    link: "/industries/government",
  },
  {
    title: "Healthcare",
    description:
      "Expert translations for medical records, research papers, and patient documents, maintaining precision, confidentiality, and adherence to healthcare regulations.",
    imageUrl: images.technical_industries4,
    link: "/use-cases/medical",
  },
  {
    title: "Law",
    description:
      "Professional translations for legal contracts, court documents, and compliance materials, ensuring accuracy, technical integrity, and alignment with legal standards.",
    imageUrl: images.technical_industries5,
    link: "/use-cases/legal",
  },
  {
    title: "Explore industries",
    description: "",
    imageUrl: images.industries_see_all,
    link: "/industries",
    isStatic: true,
  },
];

export const useCaseIndustriesData = {
  ...useCaseIndustriesContent,
  cards: useCaseIndustriesCards,
};
